import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface DeleteLineItemMutationInput {
  id: number;
  projectId: number;
}

/**
 * Mutation hook for soft-deleting a line item.
 * Calls DELETE /line-items/:id.
 * Requires projectId to correctly invalidate the project's line-items list.
 */
export function useDeleteLineItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: DeleteLineItemMutationInput) => {
      await apiClient.delete(`/line-items/${id}`);
    },
    onSuccess: (_data, { projectId }) => {
      // 3-element prefix so all list queries for this project (any filter/cursor) refetch.
      queryClient.invalidateQueries({ queryKey: ['lineItems', 'list', projectId] });
    },
  });
}
